export const useBaseUrl = () => {
  const config = useRuntimeConfig()
  const API_URL: string = `${config.public.apiBase}/api`

  return {
    API_URL
  }
}
